import {
    ChatBubbleOvalLeftEllipsisIcon,
    EllipsisHorizontalCircleIcon,
    EnvelopeIcon,
    MapPinIcon,
    PhoneIcon,
} from "@heroicons/react/24/outline";
import { ActivityCategory } from "@sp-crm/core";
import React from "react";

export const activityCategoryIcons: Record<
    ActivityCategory,
    React.ComponentType<React.SVGProps<SVGSVGElement>>
> = {
    visit: MapPinIcon,
    call: PhoneIcon,
    sms: ChatBubbleOvalLeftEllipsisIcon,
    email: EnvelopeIcon,
    other: EllipsisHorizontalCircleIcon,
};
